import http from '@core/fetch'

export default {
  relative_examples: body =>
    http('/p/wedding/Admin/APISetMealRelation/relative_examples', { body }),

  case_list: body =>
    http('/p/wedding/index.php/Admin/APISetMealRelation/allCaseList', { body }),
  // case_list: body => http(API_SETMEAL_LIST, { body }),

  package_details: body =>
    http('/p/wedding/index.php/Home/APISetMeal/info', { body }),

  add_relative_example: body =>
    http.post('/p/wedding/Admin/APISetMealRelation/add_relative_example', {
      body
    }),

  del_relative_example: body =>
    http.post('/p/wedding/Admin/APISetMealRelation/del_relative_example', {
      body
    }),

  update_relative_example: body =>
    http.post('/p/wedding/Admin/APISetMealRelation/update_relative_example', {
      body
    })
}
